export class ProductTile {

  ProductTileImgURL1: string;
  ProductTileImgURL2: string;
  ProductBlockImgURL: string;
  HotLabel: string;
  ProductURL: string;
  ProductName: string;
  CurrentPrize: string;
  OldPrize: string;
  ProductDescription: string;

  ItemId: string;
  ImageId: string;
  ItemProductTypeName: string;
  ItemName: string;
  PrimaryTagName: string;
  SKUCode: string;
  MaxRetailPrice: string;
  StrikePrice: string;

  SaveAmount: string;
  SavePercent: string;

  ItemMasterHeaderSubDescId: string;
  ItemMasterHeaderId: string;
  ItemMasterHeaderSubId: string;
  ItemMasterHeaderSubDesc: string;
  IsActive: string;
  CreatedBy: string;
  CreatedDateTime: string;
  MachineIP: string;
  ItemProductTypeId: string;
  EntryStatus: string;
  ImageList:[string];
  ColorName:string;
  ColorMapName:string;
  CollectionName:String="None";
  Notes:null;

}
